import { render, staticRenderFns } from "./SvgTransition.vue?vue&type=template&id=0bc2f330&"
import script from "./SvgTransition.vue?vue&type=script&lang=js&"
export * from "./SvgTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\priv\\svg-transition\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0bc2f330', component.options)
    } else {
      api.reload('0bc2f330', component.options)
    }
    module.hot.accept("./SvgTransition.vue?vue&type=template&id=0bc2f330&", function () {
      api.rerender('0bc2f330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/SvgTransition.vue"
export default component.exports